import { jwtAxios } from ".";

export const PROGRESS_API_URL = `/progress`;
const BASE_URL =
  process.env.REACT_APP_ENV === "development"
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_PRODUCTION;

export function progressApi(data) {
  return jwtAxios.post(BASE_URL + PROGRESS_API_URL, { data });
}
